<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
<!--  <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> -->
<canvas *ngIf="celebrate" id="CustomCanvas"></canvas>
<div class="loadingBox" *ngIf="!loaded">
    <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
   </div>
 <div *ngIf="loaded"><app-header ></app-header>
<div id="wrapper">
<app-sidebar></app-sidebar>
<div id="content-wrapper">
  
  <!-- <div *ngIf="imageSources.length > 0" class="container-slider">
           <slideshow
           [autoPlayInterval]="5000"
           [autoPlay]="true"
           [showArrows]="false"
           [imageUrls]="imageSources">
</slideshow>

         </div> -->
         <div class="container-fluid pb-0 pt-0">
          <div *ngIf="banner"  class="ctaBoxArea" [style.background-image]="'url(' + banner.imageUrl + ')'">
            <div  class="container">
              <div  class="row">
                <div  class="col cta-max">
                  <h4
                    class="ctaSubHead"
                    style="text-align: center;"
                  >
                  {{banner.description}}
                  </h4>
                  <a *ngIf="banner.externalHttpUrl != 'https://woohoo365.videyo.tv/en/'"
                    class="unsubbutton white-outline-button subButton"
                    style="font-size: 18px; width: 100%; margin-left: 0px; margin-top: 0px; line-height: 20px;text-transform: uppercase; font-weight: bold;"
                    href="{{banner.externalHttpUrl}}"
                    >Find out more</a
                  >
                </div>
              </div>
            </div>
          </div>  
            <ngx-newsticker *ngIf="eventList.length > 0" title="Latest News" [events]="eventList" [interval]="6000"></ngx-newsticker>
       <app-call-to-action *ngIf="isWoohoo && !subscribedUser"></app-call-to-action>
       <app-all-content ></app-all-content>
       <!-- <app-popular-content></app-popular-content><br/><app-recent-view></app-recent-view><br/><app-free-content></app-free-content> --></div>
      <div class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/"><i _ngcontent-c3="" class="fas fa-fw fa-home"></i> <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span></a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
 
        </div>
        </div>
      </div>
    </div>
    </div>
 
  